import ServiceInterieur from "../assets/img/Services_10.webp";
import ServiceSol from "../assets/img/Services_9.webp";
import ServiceFacade from "../assets/img/Services_3.webp";
import ServiceEnduit from "../assets/img/Services_4.webp";
import ServiceExterieur from "../assets/img/Services_5.webp";
import ServiceMural from "../assets/img/Services_6mur.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const cards = [
  {
    img: ServiceMural,
    title: "Revêtements muraux",
    target: "revetement-mur",
  },
  {
    img: ServiceSol,
    title: "Revêtements de sols",
    target: "revetement-sol",
  },
  {
    img: ServiceInterieur,
    title: "Peinture intérieure",
    target: "intérieure",
  },
  {
    img: ServiceExterieur,
    title: "Peinture extérieure",
    target: "exterieure",
  },
  {
    img: ServiceEnduit,
    title: "Enduit décoratif",
    target: "enduit",
  },
  {
    img: ServiceFacade,
    title: "Traitement de façade",
    target: "facade",
  },
];

export default function Carousel1() {
  return (
    <div>
      <div className="carousel-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={3}
          centeredSlides={true}
          loop={true}
          navigation
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          className="carousel-swiper"
          breakpoints={{
            0: { slidesPerView: 1, centeredSlides: false },
            900: { slidesPerView: 2, centeredSlides: false },
            1200: { slidesPerView: 2, centeredSlides: false },
            1400: { slidesPerView: 3, centeredSlides: true },
          }}
        >
          {cards.map((card, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="carousel-card"
                style={{
                  backgroundImage: `url(${card.img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#fff",
                  cursor: "pointer",
                  height: "450px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  const el = document.getElementById(card.target);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <div className="carousel-card-content">
                  <h3>{card.title}</h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
